// Desk Squad quick-add carousel: advances the strip one page (3 cards) every few
// seconds while the cart drawer is open. Pauses on touch, hover or focus and resumes
// after a short idle. No auto-advance for prefers-reduced-motion. Without this
// script the strip is still a native swipeable row.
if (!customElements.get('desk-squad-carousel')) {
  customElements.define(
    'desk-squad-carousel',
    class DeskSquadCarousel extends HTMLElement {
      static INTERVAL = 4000;
      static RESUME_AFTER = 6000;

      connectedCallback() {
        this.track = this.querySelector('.desk-squad-quick-add__list');
        this.dotsWrapper = this.querySelector('.desk-squad-quick-add__dots');
        this.dots = Array.from(this.querySelectorAll('.desk-squad-quick-add__dot'));
        if (!this.track || this.dots.length < 2) return;

        this.dotsWrapper.hidden = false;
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index)));
        this.track.addEventListener('scroll', () => this.updateDots(), { passive: true });

        this.pause = this.pause.bind(this);
        ['pointerdown', 'touchstart', 'mouseenter', 'focusin'].forEach((type) =>
          this.addEventListener(type, this.pause, { passive: true })
        );

        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.start();
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        clearTimeout(this.resumeTimer);
      }

      get pageCount() {
        return this.dots.length;
      }

      get cards() {
        return Array.from(this.track.children);
      }

      get currentPage() {
        const left = this.track.scrollLeft;
        let nearest = 0;
        this.cards.forEach((card, index) => {
          if (Math.abs(card.offsetLeft - left) < Math.abs(this.cards[nearest].offsetLeft - left)) nearest = index;
        });
        // At the end of the strip the last page may be partial and never reach its first card.
        if (left + this.track.clientWidth >= this.track.scrollWidth - 2) return this.pageCount - 1;
        return Math.floor(nearest / 3);
      }

      start() {
        if (this.reducedMotion) return;
        clearInterval(this.timer);
        this.timer = setInterval(() => {
          if (!this.closest('cart-drawer.active')) return;
          this.goTo((this.currentPage + 1) % this.pageCount);
        }, DeskSquadCarousel.INTERVAL);
      }

      pause() {
        clearInterval(this.timer);
        clearTimeout(this.resumeTimer);
        this.resumeTimer = setTimeout(() => this.start(), DeskSquadCarousel.RESUME_AFTER);
      }

      goTo(page) {
        const card = this.cards[page * 3];
        if (!card) return;
        this.track.scrollTo({
          left: card.offsetLeft,
          behavior: this.reducedMotion ? 'auto' : 'smooth',
        });
      }

      updateDots() {
        const current = this.currentPage;
        this.dots.forEach((dot, index) => dot.toggleAttribute('aria-current', index === current));
      }
    }
  );
}
